import { render, staticRenderFns } from "./bigimg.vue?vue&type=template&id=fa470c10&scoped=true&"
import script from "./bigimg.vue?vue&type=script&lang=js&"
export * from "./bigimg.vue?vue&type=script&lang=js&"
import style0 from "./bigimg.vue?vue&type=style&index=0&id=fa470c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa470c10",
  null
  
)

export default component.exports